import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import VButton from "../Common/VButton";

const ConfirmationDialog = (props: { isOpen: boolean; cancelGoingBack: () => void }) => {
  return (
    <Dialog open={props.isOpen}>
      <DialogTitle>Hoiatus</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Pärast testi sooritamist on võimalik alla laadida testis kasutatud sõnade kogumit (vastuste leht). Praegu on
          viimane võimalus neid alla laadida, sest hiljem ei ole võimalik neid enam kätte saada.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <VButton text="Mine avalehele" type="alert" sx={styles.button} fullWidth={false} navigate="/" />
        <VButton text="Tühista" type="outlined" sx={styles.button} fullWidth={false} onClick={props.cancelGoingBack} />
      </DialogActions>
    </Dialog>
  );
};

const styles = {
  button: {
    borderWidth: "2px",
    paddingTop: "0.5em",
    paddingBottom: "0.5em",
  },
};

export default ConfirmationDialog;
